import React from 'react';
import { Box, Chip, IconButton, Stack, Typography, useTheme } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { formatDunsNumber } from '../../dataHandlers/riskCompliancePaths';

export default function DunsLinkedStatusBar({ dunsNumber, companyName, linkedLabel, onEdit }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        py: 1.5,
        px: 2.5,
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        bgcolor: 'background.paper',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
      }}
    >
      <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
        <Typography
          component="span"
          sx={{ color: theme.palette.text.secondary, fontWeight: theme.typography.fontWeightMedium }}
        >
          D-U-N-S{' '}
        </Typography>
        <Typography
          component="span"
          sx={{ color: theme.palette.text.primary, fontWeight: theme.typography.fontWeightMedium }}
        >
          {formatDunsNumber(dunsNumber)}
        </Typography>
        <Typography component="span" sx={{ color: theme.palette.text.secondary }}>
          {' '}
          ·{' '}
        </Typography>
        <Typography
          component="span"
          sx={{ color: theme.palette.text.primary, fontWeight: theme.typography.fontWeightMedium }}
        >
          {companyName}
        </Typography>
      </Typography>

      <Stack direction="row" spacing={0.5} alignItems="center">
        <Chip
          label={linkedLabel}
          size="small"
          sx={{
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '0.75rem',
            color: theme.palette.text.secondary,
            borderColor: 'divider',
            bgcolor: theme.palette.action.hover,
          }}
          variant="outlined"
        />
        {onEdit && (
          <IconButton size="small" onClick={onEdit} aria-label="Edit linked DUNS">
            <EditOutlinedIcon fontSize="small" color="action" />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
}
